import moment from 'moment'
import {mapValues, groupBy, omit} from 'lodash'

function reformatLogDetail(log){
  let objectType = log.log_context.object_type
  let context = log.log_context;
  let operator_type = log.operator_type;
  let newLog = {};

  if(objectType === 'student' || objectType === 'lesson' || objectType === 'lesson_list'){
    if(context.operation === 'add'){
      context.operation = 'edit';
    }
  }

  if(objectType === 'lesson' || objectType === 'lesson_list'){
    if( typeof context.object_name === 'string') {
      context.object_name_list = [context.object_name];
    }
  }

  if(operator_type === 'other'){
    log.operator_name = 'Principal'
  }

  log.operated_at_date = moment(log.operated_at).format('YYYY-MM-DD')
  log.operated_at_time = moment(log.operated_at).format('hh:mm a')
  
  return log;
}

export default function (logs = {}) {
  let parsedLogList = [];
  let logList = logs.result_list;

  parsedLogList = logList.map((log)=>{
    return reformatLogDetail(log);
  })

  let newLog = mapValues(groupBy(parsedLogList, 'operated_at_date'), list => list.map(parsedLogList => omit(parsedLogList, 'operated_at_date')))
  
  Object.keys(newLog).map((key) => {
    let newList = newLog[key]
    let convertedLog = mapValues(groupBy(newList, 'operated_at_time'), list => list.map(newList => omit(newList, 'operated_at_time')))

    newLog[key] = convertedLog
  })

  return {
    ...logs,
    result_list: newLog
  };
}


// WEBPACK FOOTER //
// ./src/util/parseLog.js